import React from "react"
import SyntaxHighlighter from "react-syntax-highlighter"
import { Scrollbars } from "react-custom-scrollbars"
import { tomorrowNightEighties as style } from "react-syntax-highlighter/dist/esm/styles/hljs"

import * as s from "./index.module.less"

const Code = ({ title = "", children, lang = "json" }) => {
  return (
    <>
      {title && (
        <div className={s.header}>
          <span>{title}</span>
        </div>
      )}
      <SyntaxHighlighter
        language={lang}
        style={style}
        showLineNumbers={true}
        wrapLines={true}
        className={s.code_block}
      >
        {children}
      </SyntaxHighlighter>
    </>
  )
}

export default Code
